module.exports = __webpack_public_path__ + "static/media/ic_sec_cons_durable.b6c46fb1.svg";